import { NavPoint } from "@redux/navPoint/NavPoint";
import { createAction } from "./actionCreators";

const [useUpdateNavPoint, updateNavPoint] = createAction<Partial<NavPoint>>("navPoint/update");

export default useUpdateNavPoint;
export { updateNavPoint };
